const logo = "/logo_m4b.png";
import { ExternalLink } from "lucide-react";
import Link from "next/link";
import { LEGAL, LEGAL_LINKS } from "@/lib/legal";

const portales = [
  { name: "La Clave Noticias", url: "laclavenoticias.es" },
  { name: "El Descuento", url: "eldescuento.es" },
  { name: "El Objetivo Noticias", url: "elobjetivonoticias.es" },
];

const Footer = () => {
  // Año fijo en render para evitar mismatch SSR/cliente por huso horario
  const currentYear = 2026;

  return (
    <footer className="bg-m4b-black">
      <div className="container mx-auto px-6">
        <div className="py-16 grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src={logo} alt="M4B" className="h-10 brightness-0 invert mb-6" />
            <p className="text-primary-foreground/60 max-w-sm leading-relaxed mb-6">
              Agencia de noticias especializada en la creación y gestión de
              portales informativos temáticos.
            </p>
            <p className="text-primary-foreground/40 text-sm leading-relaxed">
              {LEGAL.companyName} · CIF {LEGAL.cif}
              <br />
              {LEGAL.address}
              <br />
              <a
                href={`mailto:${LEGAL.email}`}
                className="hover:text-primary transition-colors"
              >
                {LEGAL.email}
              </a>{" "}
              · {LEGAL.phone}
            </p>
          </div>

          <div>
            <h4 className="text-primary-foreground font-bold mb-6 text-sm tracking-wider uppercase">
              Navegación
            </h4>
            <nav className="flex flex-col gap-3">
              <a
                href="/#inicio"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Inicio
              </a>
              <a
                href="/precios"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Precios
              </a>
              <a
                href="/#portales"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Portales
              </a>
              <a
                href="/#anunciantes"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Anunciantes
              </a>
              <a
                href="/#colaboradores"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Colaboradores
              </a>
              <a
                href="/#contacto"
                className="text-primary-foreground/60 hover:text-primary transition-colors text-sm"
              >
                Contacto
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-primary-foreground font-bold mb-6 text-sm tracking-wider uppercase">
              Nuestros Portales
            </h4>
            <nav className="flex flex-col gap-3">
              {portales.map((portal) => (
                <a
                  key={portal.name}
                  href={`https://${portal.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-foreground/60 hover:text-primary transition-colors text-sm flex items-center gap-2"
                >
                  {portal.name}
                  <ExternalLink size={12} />
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="py-6 border-t border-primary-foreground/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-primary-foreground/40 text-sm text-center md:text-left">
            © {currentYear} {LEGAL.companyName}. {LEGAL.brand}. Todos los
            derechos reservados.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {LEGAL_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-primary-foreground/40 hover:text-primary text-sm transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
